import { LOCALE_ID, Component, Injector} from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from "@angular/material";
import { FormControl, FormGroup, Validators, FormBuilder, FormArray, AbstractControl } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http'; 
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { ErrorStateMatcher } from '@angular/material/core';
import * as moment from 'moment';
import Swal from "sweetalert2";
import { MessagesDates, MessagesGeneral, MessagesTitles, MessagesSimuladorAgregarDetalle } from '../../../../models/messages';
import { ProformaDetalle } from '../../../../models/ProformaDetalle';
import { DocumentoNegociableService } from '../../../../services/documento-negociable/documento-negociable.service';
import { LocalService } from '../../../../services/storage/localService';
import { ProformaService } from '../../../../services/operaciones/proforma/proforma.service';
import { LoginService } from 'app/services/login/login.service';
import { GuiasService } from 'app/services/guias/guias.service';
import { EmpresasService } from 'app/services/empresas/empresas.service';
import { environment } from 'environments/environment';
import { RiesgoService } from '../../../../services/riesgo/riesgo.service';
import { InversionistaDetalle } from '../../../../models/InversionistaDetalle';
import localeEs from '@angular/common/locales/es'
import { registerLocaleData } from '@angular/common'
import { Router,ActivatedRoute, Params } from "@angular/router";
import { OperacionService } from '../../../../services/operaciones/operacion/operacion.service';
registerLocaleData(localeEs, 'es');

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

declare var $: any;

@Component({
  selector: 'app-deposito-inversion',
  templateUrl: './deposito-inversion.component.html',
  styleUrls: ['./deposito-inversion.component.scss'],
  providers: [DatePipe, MessagesTitles, MessagesGeneral, MessagesDates, MessagesSimuladorAgregarDetalle,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },{ provide: LOCALE_ID, useValue: 'es'},

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})

export class DepositoInversionComponent{
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_Proformas=environment.LABEL_PROFORMAS;
  Label_Proforma=environment.LABEL_PROFORMA;
  Id_Confirming=environment.ID_CONFIRMING;
  Id_Factoring=environment.ID_FACTORING;
  Id_Descuento=environment.ID_DESCUENTO;
  MILISENGUNDOS_POR_DIA = 1000 * 60 * 60 * 24;

  varDiasMin: any = 0;
  varDiasMax: any = 0;
  varAdelantoMin: any = 0;
  varAdelantoMax: any = 0;
  varAdelantoDef: any = 0;
  varTasaMin: any = 0;
  varTasaMax: any = 0;
  IGV_Porcentaje: any = 0;
  igvPorcentajeGlobal: any = 0;
  flgCalcular: boolean = false;
  arrayDocumentos: any = [];
  actualizarDocumentos: any = [];
  user: any;
  minFromDateOriginal = new Date();
  minFromDate = new Date();
  nroFacturas: number =0;
  TEM: number = 0;
  TEMAutomatico: number = 0;
  flgTEMAutomatico: boolean = false;
  flgNotificar: boolean = false;
  loading: boolean = false;
  formTEM: FormGroup;
  formProforma: FormGroup;
  proformaDetalle: ProformaDetalle[] = [];
  rProveedor: any = [];
  Nombre_de_Contacto: string = "";
  correo: string = "";
  idProforma: number = 0;
  idProveedor: number = 0;
  ProformaSave: any = [];
  optionValue;
  tipoServicioElement = this.Id_Factoring;
  sumainteres: number = 0;
  ocultarAdq: boolean = false;
  comisionPeso: number = 0; ç
  prospectoFiltroAdq: any;
  prospectoFiltroProv: any;
  boton: boolean = true; 
  fondos: any = [{
    "Monto_Fondo_Disponible": 0}];
  flagRetroventa: boolean = false;
  PlazoForm: number = 20;

  inversionistaDetalle : InversionistaDetalle[] = [];

  inversionId: any; 
  update: boolean = false;
  action:string = "crear";
  titulo:string = "crear";
  form: FormGroup;
  
  varAbrirInversionista : boolean = false;
  ProformaTotales: any = {
    VNPP: 0,
    Adelanto: 0,
    Interes: 0,
    InteresAdq: 0,
    InteresProv: 0,
    Comision: 0,
    IGV_TOTAL: 0,
    Desembolso: 0,
    Remanente: 0,
    IGVProv: 0,
    CAVALI: 0,
    Firma: 0, 
    Otros : 0,
    Desembolso_importe : 0, 
    DesembolsoProvConfirming: 0,
    Costo_Total_Operacion: 0,
    TAI: 0,
    Plazo:0,
    RetencionFuente :  0,
    RetencionIVA :  0,
    Valor_Venta_Retroventa :  0,
    Valor_Venta_Retroventa_Saldo :  0,
    Otros_Descuentos :  0,
    fecha_inversion :  0,
    fecha_desembolso :  0,
    fecha_vencimiento :  0,
  };

  ProformaConDetalle: any = {
    proforma_detalle: [],
    idEmpresa: 1
  };

  datosDN: any;
  check0: boolean = false;
  Date = new Date();
  PlazoMaximo = 0;
  data: any;
  proformaGeneral: any = {
    "Num_Doc_Identificacion_Prov": "",
    "Num_Doc_Identificacion_ADQ": "",
    "Ranking_Adquirente": "",
    "Tasa_Tipo_de_Calculo": "",
    "Tasa_Anual": "",
    "Tasa_Mensual_Sistema": "",
    "Tasa_Mensual": "",
    "Tasa_Diaria": "",
    "Moneda": "",
    "Adelanto_porcentaje": "",
    "Cantidad_de_Documentos_Negociables": "",
    "Fecha_Desembolso": "",
    "Fecha_Vigencia": "",
    "Adjunto_PDF": "",
    "TAI": "",
    "idProforma": "",
    "ProformaDetalle": []
  }

  empresasService: EmpresasService;
  proformaService: ProformaService;
  documentoNegociableService: DocumentoNegociableService;
  loginService: LoginService;
  localService: LocalService;
  guiasService: GuiasService;
  riesgoService:RiesgoService;

  constructor(private injector : Injector,
    private datepipe: DatePipe,
    private msgAgregarSimulador: MessagesSimuladorAgregarDetalle,
    private msgTitulos: MessagesTitles,
    private activateRoute :ActivatedRoute,
    private operacionService:OperacionService,
    private formBuilder: FormBuilder,
    private router: Router
  ){
    this.empresasService = this.injector.get<EmpresasService>(EmpresasService);
    this.proformaService = this.injector.get<ProformaService>(ProformaService);
    this.documentoNegociableService = this.injector.get<DocumentoNegociableService>(DocumentoNegociableService);
    this.loginService = this.injector.get<LoginService>(LoginService);
    this.localService = this.injector.get<LocalService>(LocalService);
    this.guiasService = this.injector.get<GuiasService>(GuiasService);
    this.riesgoService = this.injector.get<RiesgoService>(RiesgoService);

    this.varDiasMin = this.localService.getJsonValue('ParametroRechazoMin');
    this.varDiasMax = this.localService.getJsonValue('ParametroRechazoMax');
    this.varAdelantoMin = (this.localService.getJsonValue('ParametroAdelantoMinimo') * 100);
    this.varAdelantoMax = (this.localService.getJsonValue('ParametroAdelantoMaximo') * 100);
    this.varAdelantoDef = (this.localService.getJsonValue('ParametroAdelandoDefault') * 100);
    this.varTasaMin = this.localService.getJsonValue('ParametroTasaMinimoComercial');
    this.varTasaMax = this.localService.getJsonValue('ParametroTasaMaximo');
    this.igvPorcentajeGlobal = this.localService.getJsonValue('ParametroIGVPorcentaje');

    try {
      this.user = JSON.parse(sessionStorage.getItem('UserActive'));
      this.datosDN = this.proformaService.datosProforma; 
     // this.ObtenerRanking();
    } catch (error) {
      console.log(error);
      //this.loginService.clickGuard = true;
      //this.router.navigate(['/operaciones/proformas/listado']);
    }

    let now = moment();
    this.activateRoute.params.subscribe( (params:Params):void => {      
      if(params['id'] != undefined){
        this.loading = true; 
        this.inversionId = params['id'];
        this.update = true;
        this.titulo = "Retirar fondo";

        this.data = {          
          "idFinanciamiento":0,
          "idFondo":this.inversionId
        }
        
        this.listarFondos(this.inversionId); 
        console.log('aaa', this.fondos);
      }
    }) 

  }

  ngOnInit() { 
    
    this.form = this.formBuilder.group({
      idFondo: this.data.idFondo,
      Monto_Fondo: ['0.00', [Validators.required]],
      Tipo: ['t', [Validators.required]],
      Fecha_Inicio: ['', [Validators.required]], 
      Observaciones: '', 
      Anexos: ''
    });
    
  }
  DeleteInversionista(id: any,valor : any){
    this.inversionistaDetalle.splice(id, 1);
    this.ProformaTotales.Valor_Venta_Retroventa_Saldo = this.ProformaTotales.Valor_Venta_Retroventa_Saldo+valor;
}
  RecibirInversionistaDetalle(event){
    this.inversionistaDetalle.push(event); 
    this.varAbrirInversionista = false;
    let total_inversion = 0;
    this.inversionistaDetalle.forEach(element => {
      total_inversion += element.Valor_Inversion;
    });
    this.ProformaTotales.Valor_Venta_Retroventa_Saldo = this.ProformaTotales.Valor_Venta_Retroventa-total_inversion;
    //this.obtenerTEM();
  }
  asignarTipoFondo(event) {
     
  }
  listarFondos(idFondo) {
    this.riesgoService.obtenerFondos().subscribe(
      resp => {
        this.fondos = resp
        this.fondos.sort(function(a, b) {
          var textA = a.Razon_Social;
          var textB = b.Razon_Social;
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        this.fondos = this.fondos.filter(item => item.idFondo == idFondo);
        
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
       // this.msgStatus.getMessage(err.status);
        Swal.fire({
          title: 'error',
          text: "LISTA FONDOS NO OBTENIDO. ",
          type: "error",
          allowOutsideClick: false
        });
      });
  }
  openCloseRetroventa(){
    this.flagRetroventa = !this.flagRetroventa;
    if(!this.flagRetroventa){
      this.formTEM.controls['Valor_Venta_Retroventa'].setValue(0);
    }else{
      this.formTEM.controls['Adelanto_Porcentaje'].setValue(0);
    }
    
  }
  MetCerrarsimuladorDetalle(){ 
    this.varAbrirInversionista = false;
  }
  AbriInversionista(){
    console.log("-->",this.ProformaTotales);
    this.varAbrirInversionista = true;
  }
  calcularComision(){
    let porcentaje = this.formTEM.controls['Comision_Porcentaje'].value;
    let comision = this.ProformaTotales.Adelanto * porcentaje/100;
    console.log(porcentaje,comision);
    this.formTEM.controls['Comision'].setValue(Math.round(comision*100)/100);
  }
  calcularPorcentaje(){
    let comision = this.formTEM.controls['Comision'].value;
    let porcentaje = comision/this.ProformaTotales.Adelanto *100;
    console.log(porcentaje,comision);
    this.formTEM.controls['Comision_Porcentaje'].setValue(Math.round(porcentaje*10000000)/10000000);
  }
  calcularTasaAllIn(){
    console.log("Tasa_all",this.ProformaTotales);
    console.log("1111",this.ProformaTotales.Comision);
    console.log("2222",this.ProformaTotales.Interes);
    console.log("333",this.ProformaTotales.VNPP);
    console.log("444",this.ProformaTotales.Plazo);
    let tasa = (this.ProformaTotales.Comision+this.ProformaTotales.Interes)/this.ProformaTotales.VNPP/this.ProformaTotales.Plazo *30*100;
    console.log(tasa);
    this.ProformaTotales.TAI= Math.round(tasa*100)/100;
  }
  calcularProforma(modo : boolean, TEM: number){
    this.resetear(); 
    this.loading = true;
    let plazo: any = [];
    this.PlazoMaximo = 0;
    let sumaVNPP: number = 0.00;
    this.TEM = 0;
    this.nroFacturas = 0;
    let TotalRetencionFuente : number = 0;
    let TotalRetencionIVA : number = 0;

    for (let item of this.proformaDetalle) {
      if (item.checked) {
        this.nroFacturas++;
        plazo.push(item.Plazo);
        sumaVNPP += Number(item.VNPP);
      }
    }

    if (plazo.length > 0) this.PlazoMaximo = Math.max(...plazo);

    this.formTEM.controls['TipoCambio'].setValue(this.datosDN.TipoMoneda);
    this.formTEM.controls['Num_Doc_Identificacion_Prov'].setValue(this.datosDN.Num_Doc_Identificacion_Prov);
    this.formTEM.controls['Num_Doc_Identificacion_ADQ'].setValue(this.datosDN.Num_Doc_Identificacion_Adq);
    this.formTEM.controls['Plazo'].setValue(this.PlazoMaximo);
    this.formTEM.controls['VNPP'].setValue(sumaVNPP);
    console.log("ver datos_dn",this.datosDN);
    let CUOTA_EXTRAORDINARIA = (this.datosDN.Num_Doc_Identificacion_Adq == '1390073891001')? 0.02:0;
    console.log('cuota  extra',CUOTA_EXTRAORDINARIA);
    if(this.formTEM.value.VNPP>0){
      if(modo){
        this.editarTEM();
      }
      this.proformaService.obtenerTEM(this.formTEM.value,1).subscribe(
        responseTEM => {
          this.TEMAutomatico = Number(responseTEM);
          if(modo){
            this.TEM = Number(responseTEM);
            this.flgTEMAutomatico = false;
          } else {
            this.TEM = TEM;
            this.flgTEMAutomatico = true;
          }
          let cont_facturas = 0;
          this.proformaDetalle.forEach((item,index)=>{
            this.sumainteres = 0;
            if (item.checked){
              let por_valor = Number(item.VNPP)/Number(sumaVNPP);
              let Valor_porcentaje_calculado = this.formTEM.controls['Valor_Venta_Retroventa'].value*por_valor;
              item.TEM = this.TEM;
              item.pPAdelanto  =  this.formTEM.controls['Adelanto_Porcentaje'].value/100;
              item.Moneda =  this.formTEM.controls['TipoCambio'].value;
              item.Porcentaje_Interes_Adquirente = this.formTEM.controls['Interes_Adquirente'].value/100;
              item.Tipo_Servicio = this.formTEM.controls['Tipo_Servicio'].value;
              item.Comision_importe = this.formTEM.controls['Comision'].value;
              item.Otros_Descuentos = this.formTEM.controls['Otros'].value;
              item.nroFacturas = this.nroFacturas;
              item.Valor_Venta_Retroventa = Valor_porcentaje_calculado;
              item.ComisionPorcentaje = this.formTEM.controls['Comision_Porcentaje'].value;
              item.IdProveedor = (this.datosDN.idProveedor)?this.datosDN.idProveedor:0;
              item.IdAdquirente = (this.datosDN.idAdquirente)?this.datosDN.idAdquirente:0;
              this.proformaService.factoring(item,1).subscribe(
                responseFactoring => {
                  this.proformaDetalle[index].Adelanto_importe = responseFactoring['Adelanto'];
                  this.proformaDetalle[index].Remanente_importe = responseFactoring['Remanente'];
                  this.proformaDetalle[index].Interes_importe = responseFactoring['Interes'];
                  this.proformaDetalle[index].InteresProv = responseFactoring['InteresProv'];
                  this.proformaDetalle[index].InteresAdq = responseFactoring['InteresAdq'];
                  this.proformaDetalle[index].IGVProv = responseFactoring['IGVProv'];
                  this.proformaDetalle[index].IGV = responseFactoring['IGV'];
                  this.proformaDetalle[index].IGVAdq = responseFactoring['IGVAdq'];
                  this.proformaDetalle[index].CAVALI_importe = responseFactoring['Timbre'];
                  this.proformaDetalle[index].firma_importe = responseFactoring['Feci'];
                  this.proformaDetalle[index].otros_importe = responseFactoring['G_cesion'];
                  this.proformaDetalle[index].Comision_importe = responseFactoring['Comision'];
                  this.proformaDetalle[index].RetencionFuente = responseFactoring['RetencionFuente'];
                  this.proformaDetalle[index].RetencionIVA = responseFactoring['RetencionIVA'];
                  
                  this.proformaDetalle[index].Desembolso_importe = responseFactoring['Desembolso'];
                  
                  this.proformaDetalle[index].DesembolsoProvConfirming = this.proformaDetalle[index].Desembolso_importe;
                  
                  
                  this.ProformaTotales.VNPP += Number(this.proformaDetalle[index].VNPP);
                  this.ProformaTotales.Adelanto += Number(responseFactoring['Adelanto']);
                  this.ProformaTotales.Interes += Number(responseFactoring['Interes']);
                  this.ProformaTotales.Remanente += Number(responseFactoring['Remanente']);
                  this.ProformaTotales.CAVALI += Number(responseFactoring['Timbre']);
                  this.ProformaTotales.Firma += Number(responseFactoring['Feci']);
                  this.ProformaTotales.Otros += Number(responseFactoring['G_cesion']);
                  this.ProformaTotales.Comision += Number(responseFactoring['Comision']);
                  this.ProformaTotales.IGVProv += Number(responseFactoring['IGV']); 
                  this.ProformaTotales.RetencionFuente += Number(responseFactoring['RetencionFuente']); 
                  this.ProformaTotales.RetencionIVA += Number(responseFactoring['RetencionIVA']);  
                  this.ProformaTotales.Desembolso_importe += Number( this.proformaDetalle[index].Desembolso_importe);                  
                  this.ProformaTotales.Costo_Total_Operacion += Number(responseFactoring['Costo_Total_Operacion']);
                  this.ProformaTotales.Plazo = this.PlazoMaximo;
                  this.ProformaTotales.Valor_Venta_Retroventa =  Number(this.ProformaTotales.Adelanto-this.ProformaTotales.Interes); 
                  this.ProformaTotales.Valor_Venta_Retroventa_Saldo = Number(this.ProformaTotales.Adelanto-this.ProformaTotales.Interes); 
                  this.ProformaTotales.Otros_Descuentos = Number(this.ProformaTotales.Interes*Number(CUOTA_EXTRAORDINARIA)); 
                  cont_facturas++; 
                  console.log("ver interes",this.ProformaTotales.Interes);
                  console.log("ver cuota",CUOTA_EXTRAORDINARIA);
                  console.log("ver ope",Number(this.ProformaTotales.Interes*Number(CUOTA_EXTRAORDINARIA)));
                  console.log("ver valor",this.ProformaTotales);
                 
                  
                  this.flgCalcular = true;
                  this.loading = false;
                }
              )
            } else {
              this.proformaDetalle[index].Adelanto_importe = 0;
              this.proformaDetalle[index].Remanente_importe = 0;
              this.proformaDetalle[index].Desembolso_importe = 0;
              this.proformaDetalle[index].Comision_importe = 0;
              this.proformaDetalle[index].Interes_importe = 0;
              this.proformaDetalle[index].InteresAdq = 0;
              this.proformaDetalle[index].InteresProv = 0;
              this.proformaDetalle[index].IGV_Importe = 0;
              this.proformaDetalle[index].IGV_porcentaje = 0;
              this.proformaDetalle[index].IGVProv = 0;
              this.proformaDetalle[index].DesembolsoProvConfirming = 0; 

              this.ProformaTotales = {
                VNPP : 0,
                Adelanto :  0,
                Interes :  0,
                InteresAdq :  0,
                InteresProv :  0,
                Comision :  0,
                IGV_TOTAL :  0,
                Desembolso :  0,
                Remanente :  0,
                IGVProv : 0,
                CAVALI : 0,
                Firma : 0,
                Otros : 0,
                Desembolso_importe : 0, 
                DesembolsoProvConfirming : 0,
                Costo_Total_Operacion : 0,
                Valor_Venta_Retroventa : 0,
                Valor_Venta_Retroventa_Saldo : 0,
                Otros_Descuentos : 0
              };
            }
          }) 
          
        });
    } else {
      this.resetear();
      this.loading = false;
    }
  }
  
  ObtenerRanking() {
    this.proformaService.obtenerRanking(this.datosDN.Num_Doc_Identificacion_Adq).subscribe(
      res => {
        this.formTEM.controls['Ranking'].setValue(res);
      },err => {
        let error = "";
          error = err.error.error;
          this.formTEM.controls['Ranking'].setValue(0);
        this.showNotification('warning', 'top', 'right', 'Error al intentar obtener ranking. \n Error: ' + error);
        this.boton = true;
      }
    );
  }

  validarProvAdq(rucProv, rucAdq) {
    let proveedoresArr = [];
    let adquirentessArr = [];
  

    proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    adquirentessArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));

    for (let item of proveedoresArr) {
      if (item.Num_Doc_Identificacion == rucProv && item.Estado != "A") {

        Swal.fire({
          title: '¡Alto!',
          text: this.Label_Proveedor+' bloqueado, no puede continuar.',
          type: 'error',
          allowOutsideClick: false,
          heightAuto: false
        });
        this.loginService.clickGuard = true;
        this.router.navigate(["/operaciones/proformas/documentos"]);
        this.ObtenerDocumentosNegociables();
        break;
      }
    }

    for (let item of adquirentessArr) {
      if (item.Num_Doc_Identificacion == rucAdq && item.Estado != "A") {

        Swal.fire({
          title: '¡Alto!',
          text: this.Label_Adquirente+' bloqueado, no puede continuar.',
          type: 'error',
          allowOutsideClick: false,
          heightAuto: false
        });
        this.loginService.clickGuard = true;
        this.router.navigate(["/operaciones/proformas/documentos"]);
        this.ObtenerDocumentosNegociables();
        break;
      }
    }

 
  }

  ObtenerDocumentosNegociables() {

    this.loading = true;

    let Datos: any = {
      Tipo_Comprobante: '',
      Moneda: 0,
      Num_Doc_IdentificacionProv: '',
      Num_Doc_IdentificacionADQ: '',
      Tipo_Operacion: 'PR'
    };

    Datos.Tipo_Comprobante = this.datosDN.Tipo_Comprobante;
    Datos.Moneda = this.datosDN.TipoMoneda;
    Datos.Num_Doc_IdentificacionProv = this.datosDN.Num_Doc_Identificacion_Prov;
    Datos.Num_Doc_IdentificacionADQ = this.datosDN.Num_Doc_Identificacion_Adq;

    this.proformaService.ObtenerDocumentosNegociables(Datos).subscribe(
      res => {
        this.arrayDocumentos = res;
        this.resetear();
        this.loading = false;
      });
  }

  diferenciaEntreDiasEnDias(a, b) {
    var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.floor((utc1 - utc2) / this.MILISENGUNDOS_POR_DIA);
  }
  calculateFechaPago(){
    console.log(this.formTEM.controls['PlazoProforma'].value);
    //this.minFromDate = this.minFromDateOriginal;
    //this.minFromDate.setDate(this.minFromDateOriginal.getDate() + this.formTEM.controls['PlazoProforma'].value);
   
    let now  =    moment(this.formTEM.controls['Fecha_Desembolso'].value);
    now.add(this.formTEM.controls['PlazoProforma'].value, 'days');
    
    this.formTEM.controls['Fecha_Pago_Operacion'].setValue(now);
    this.resetear();
  }
  resetear(){
    this.flgCalcular = false;
    this.proformaDetalle = [];
    
    this.inversionistaDetalle  = [];
    this.arrayDocumentos.forEach((item,index) => {
      this.proformaDetalle.push(item as ProformaDetalle);

      let fecha = moment(item.Fecha_de_Pago);
      this.proformaDetalle[index].Plazo = this.diferenciaEntreDiasEnDias(this.formTEM.controls['Fecha_Pago_Operacion'].value._d, this.formTEM.controls['Fecha_Desembolso'].value._d);
      this.formTEM.controls['PlazoProforma'].setValue(this.proformaDetalle[index].Plazo);
      this.proformaDetalle[index].Adelanto_importe = 0;
      this.proformaDetalle[index].Interes_importe = 0;
      this.proformaDetalle[index].Comision_importe = 0;
      this.proformaDetalle[index].InteresAdq = 0;
      this.proformaDetalle[index].InteresProv = 0;
      this.proformaDetalle[index].IGV_Importe = 0;
      this.proformaDetalle[index].Desembolso_importe = 0;
      this.proformaDetalle[index].Remanente_importe = 0;
      this.proformaDetalle[index].IGVProv = 0;
      this.proformaDetalle[index].DesembolsoProvConfirming = 0;
      this.proformaDetalle[index].ComisionTotal = 0;
      this.proformaDetalle[index].IGV_porcentaje = 0;
      this.proformaDetalle[index].IGVAdq = 0;
      this.proformaDetalle[index].Porcentaje_Interes_Adquirente = 0;
    });

    this.ProformaTotales = {
      VNPP: 0,
      Adelanto: 0,
      Interes: 0,
      InteresAdq: 0,
      InteresProv: 0,
      Comision: 0,
      IGV_TOTAL: 0,
      Desembolso: 0,
      Remanente: 0,
      IGVProv: 0,
      CAVALI : 0,
      Firma : 0,
      Otros : 0,
      Desembolso_importe : 0, 
      DesembolsoProvConfirming: 0,
      Costo_Total_Operacion : 0
    };

  }

  guardarProforma() {
    console.log("ASD",this.form.get("Monto_Fondo").value);
    if (this.form.get("Monto_Fondo").value <=0 ) {
      Swal.fire({
        title: `Monto no autorizado`,
        text: `Se necesita como mínimo un deposito mayor a $ 0.00`,
        heightAuto: false
      });
      return;
    }
    Swal.fire({
      title: 'Espere',
      text: 'Guardando información',
      type: 'info',
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
    this.proformaService.DepositarSaldo(this.form.getRawValue()).subscribe(
      responseProforma => {
        this.ProformaSave = responseProforma;
            
          Swal.fire({
            title: 'Registrado con éxito',
            type: 'success',
            allowOutsideClick: true
          });
          this.loginService.clickGuard = true;
          this.router.navigate(["/fondo/concentracion/fondos/listado"]);
            
              
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error.code == 500) {
          err.error.error = "Problemas con el sistema, por favor contactarse con soporte"
        }
        Swal.fire({
          title: "Ha ocurrido un error",
          text: err.error.error,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );
  }

  validar(){
    if (this.formTEM.controls.Tipo_Servicio.value == this.Id_Factoring || this.formTEM.controls.Tipo_Servicio.value == this.Id_Descuento) {
      this.proformaGeneral.Porcentaje_Interes_Adquirente = 0
    }

    
    for (let item of this.proformaDetalle) {
      if (item.checked) {

        if (item.Plazo < this.varDiasMin) {
          Swal.fire({
            title: `${this.msgTitulos.Error_Fuera_Rango}`,
            text: `${this.msgAgregarSimulador.Error_Plazo_Dias}`,
            heightAuto: false
          });
          return;
        }

        if (item.Desembolso_importe <= 0) {
          Swal.fire({
            title: `${this.msgTitulos.Error_Valor_Negativo}`,
            text: `${this.msgAgregarSimulador.Error_Desemboldo}`,
            heightAuto: false
          });
          return;
        }

      
        item.Factoring_importe = item.Interes_importe + item.Comision_importe;
        item.Factoring_SUNAT_importe = item.Interes_importe + item.Comision_importe + item.IGV_Importe;
        this.proformaGeneral.Cantidad_de_Documentos_Negociables += 1;
        this.proformaGeneral.ProformaDetalle.push(item);

      }
    }

    if (this.proformaGeneral.ProformaDetalle.length <= 0) {
      Swal.fire({
        title: "Atención",
        text: "Seleccione al menos un documento",
        type: "warning",
        allowOutsideClick: false,
        heightAuto: false
      });
    }
  }

  actualizarDocumentosN(docs: any[]) {
    for (let item of docs) {
      this.documentoNegociableService.CambiarEstadoComprobante(item, item.idComprobante).subscribe(
        res => {
          console.log('Documento Negociable actualizado')
        });
    }
  }

  editarTEM() {
    Swal.fire({
      title: 'Ingresar TEM',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Cambiar',
      reverseButtons: true,
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      heightAuto: false,
    }).then((result) => {
      if (result.dismiss) {
        return;
      }
      if (result.value < (this.varTasaMin * 100) || result.value > (this.varTasaMax * 100)) {
        Swal.fire({
          title: `${this.msgTitulos.Error_Fuera_Rango}`,
          text: `${this.msgAgregarSimulador.Error_TEM}`,
          heightAuto: false
        })
        return;
      }
      this.calcularProforma(false, result.value / 100);
    })
  }

  showNotification(type, from, align, message) {

    //const type = ['','info','success','warning','danger']; => tipo de notificacion
    //from = [Top,bottom,etc] => orientacion vertical
    //align = center, left, right => orientacion horizontal

    $.notify({
      icon: "notifications",
      message: message
    }, {
      type: type,
      timer: 4000,
      placement: {
        from: from,
        align: align
      },
      template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }
}

 